import { Formik } from "formik";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Accordion,
  Button,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import { FaRegCalendarAlt } from "react-icons/fa";
import {
  Autocomplete,
  LoadScript,
  useJsApiLoader,
} from "@react-google-maps/api";
import { Dropdown } from "primereact/dropdown";
import UserContext from "../../components/context/UserContext";
import BookingCalendar from "../Dashboard/BookingCalendar";
import RotateDevicePopup from "../../components/RotateDevicePopup/RotateDevicePopup";
import { google_places_key } from "../../constants/Constants";

function Bookings() {
  let service = JSON.parse(localStorage.getItem("services"));
  let vendor_id = JSON.parse(localStorage.getItem("userId"));
  const vendorProfile = JSON.parse(localStorage.getItem("vendorProfile")) || {};

  const taxPercentage = parseFloat(vendorProfile?.tax || 0);
  // const [searchParams] = useSearchParams();
  // let group_id = searchParams.get("group_id");
  let { group_id } = useParams();
  // let display_booking_id = group_id;
  if (group_id) {
    group_id = group_id?.split("_")[group_id?.split("_")?.length - 1];
  }

  const [services, setServices] = useState(service);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [isCountrySet, setIsCountrySet] = useState(false);

  // useEffect(() => {
  //   if (vendorProfile && countries.length > 0) {
  //     const matchedCountry = countries.find(
  //       (c) =>
  //         c.name.toLowerCase() ===
  //         vendorProfile.vendor_country?.toLowerCase()
  //     );

  //     if (matchedCountry) {
  //       setInitialValues((prev) => ({
  //         ...prev,
  //         country: Number(matchedCountry.country_id),
  //       }));
  //     }
  //   }
  // }, [vendorProfile, countries]);

  const [initialValues, setInitialValues] = useState({
    partner: 1,
    org_id: "",
    userName: "",
    phoneNumber: "",
    email: "",
    house_no: "",
    area: "",
    location: "",
    location_id: "",
    state: "",
    landmark: "",
    country: "",
    lat: "",
    lng: "",
    // time: "",
    status: 0,
    payment: 0,
  });

  const [loading, setLoading] = useState(false);
  const [selectedService, setSelectedService] = useState(service?.[0] || {});
  const [initialServiceData, setInitialServiceData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [activeType, setActiveType] = useState("null");
  const [groupedData, setGroupedData] = useState({});
  const sectionsRef = useRef({});
  const scrollContainerRef = useRef(null);
  const isScrollingRef = useRef(false);
  let isScroll = false;
  const [dateSelect, setDateSelect] = useState("");
  const [timeSelect, setTimeSelect] = useState("");
  const [additionalNotes, setAdditionalNotes] = useState("");
  const [discount, setDiscount] = useState(0);
  const [priceSection, setPriceSection] = useState([]);
  const [showCalender, setShowCalender] = useState(false);
  const [providerSelected, setProviderSelected] = useState([]);
  const { id } = useParams();
  const [locationError, setLocationError] = useState("");
  const isEditing = Boolean(id);
  let navigate = useNavigate();
  const [timeRange, setTimeRange] = useState({ startTime: "", endTime: "" });
  const [customItems, setCustomItems] = useState([]);
  const { vendor, refreshVendorData } = useContext(UserContext);
  const [filteredAppointments, setFilteredAppointments] = useState([
    {
      title: "Worker 1",
      search: "Worker 1",
      start: "2025-11-27T09:00:00",
      end: "2025-11-27T09:30:00",
      status: 10,
      className: "status-15",
      extendedProps: {
        search: "Worker 1",
        start: "2025-11-27T09:00:00",
      },
    },
    {
      title: "Worker 2",
      search: "Worker 2",
      start: "2025-11-27T09:00:00",
      end: "2025-11-27T09:30:00",
      status: 10,

      className: "status-15",
      extendedProps: {
        search: "Worker 1",
        start: "2025-11-27T09:00:00",
      },
    },
    {
      title: "Worker 1",
      search: "Worker 1",
      start: "2025-11-27T10:00:00",
      end: "2025-11-27T10:30:00",
      status: 15,
      className: "status-15",
      extendedProps: {
        search: "Worker 1",
        start: "2025-11-27T10:00:00",
      },
    },
  ]);
  const [initialAppointments, setInitialAppointments] = useState([]);
  const [partner_id, setPartner_id] = useState(1);
  const [partners, setPartners] = useState([]);
  const [user_id, setUser_id] = useState(0);
  const flagCount = useRef(0);
  const [bookingStatus, setBookingStatus] = useState([]);
  const [recentBookings, setRecentBookings] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [firstLocation, setFirstLocation] = useState(null);
  const [existingData, setExistingData] = useState([]);
  const [open, setOpen] = useState(false);
  const [maxTime, setMaxTime] = useState(30);
  const [showOrderConf, setShowOrderConf] = useState(false);
  const [modelData, setModelData] = useState({});
  const [display_booking_id, setDisplay_booking_id] = useState("");
  const [editable, setEditable] = useState(true);
  const [currency, setCurrency] = useState("AED");
  const [calenderMessage, setCalenderMessage] = useState("");
  const [paidAmount, setPaidAmount] = useState(0);
  // const [balanceDue, setBalanceDue] = useState(0);

  // console.log("calenderMessage---", calenderMessage);

  // console.log("providerSelected--", providerSelected);
  // console.log("initialValues--", initialValues);

  // Validation Schema
  const validationSchema = Yup.object().shape({
    partner: Yup.string().required("Profile is required"),
    phoneNumber: Yup.string()
      .required("Phone Number is required")
      // .matches(/^[0-9]+$/, "Phone Number must be numeric")
      .test("country-specific-length", function (value) {
        if (!value) return true;
        const cleanedValue = value.replace(/\D/g, "");
        if (cleanedValue.startsWith("91")) {
          return (
            cleanedValue.length >= 12 ||
            this.createError({
              message:
                "Please enter a valid Indian phone number (min 10 digits)",
            })
          );
        }
        if (cleanedValue.startsWith("971")) {
          return (
            cleanedValue.length >= 12 ||
            this.createError({
              message: "Please enter a valid UAE phone number (min 9 digits)",
            })
          );
        }
        // Default: minimum 10 digits (including country code)
        return (
          cleanedValue.length >= 10 ||
          this.createError({
            message: "Please enter a valid phone number (min 10 digits)",
          })
        );
      }),
    userName: Yup.string()
      .required("Customer name is required")
      .min(2, "Customer name must be at least 2 characters")
      .max(20, "Customer name must not exceed 20 characters"),

    house_no: Yup.string()
      .required("Street / House no. is required")
      // .min(5, "Street address must be at least 5 characters")
      .max(100, "Street address must not exceed 100 characters"),

    area: Yup.string().required("Area is required"),
    location: Yup.string().required("Location is required"),
    state: Yup.string().when("country", {
      is: (country) => {
        const selected = countries.find(
          (c) => Number(c.country_id) === Number(country)
        );

        return selected?.name?.toLowerCase().includes("india");
      },
      then: (schema) => schema.required("State is required"),
      otherwise: (schema) => schema.required("Emirate is required"),
    }),
    country: Yup.string().required("Country is required"),
    // time: Yup.string().required("Time is required"),

    lat: Yup.string().test(
      "is-valid-latitude",
      "Invalid latitude value",
      (value) => {
        if (!value) return true;
        const numValue = parseFloat(value);
        return !isNaN(numValue) && numValue >= -90 && numValue <= 90;
      }
    ),
    lng: Yup.string().test(
      "is-valid-longitude",
      "Invalid longitude value",
      (value) => {
        if (!value) return true;
        const numValue = parseFloat(value);
        return !isNaN(numValue) && numValue >= -180 && numValue <= 180;
      }
    ),
    // status: Yup.string().required("Status is required"),
    // payment: Yup.string().required("Payment is required"),
  });

  useEffect(() => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    setCurrency(userDetails?.currency);
  }, []);

  useEffect(() => {
    getAllServices();
  }, [partner_id]);

  useEffect(() => {
    fetchServiceData(selectedService);
  }, [selectedService]);

  useEffect(() => {
    let today = new Date();
    let d1 = today.toLocaleDateString("en-GB").split(/[\/\-\.]/);
    let d2 = `${d1[2]}-${d1[1]}-${d1[0]}`;
    setDateSelect(d2);
    // getAllServices();
    fetchPartners();
  }, [group_id]);

  useEffect(() => {
    const scrollEl = scrollContainerRef.current;
    if (!scrollEl) return;

    const handleScroll = () => {
      if (isScrollingRef.current) return;
      if (isScroll) return;

      // console.log("scroll------");
      const scrollPos = scrollEl.scrollTop; // adjust offset

      for (const type of serviceTypes) {
        const section = sectionsRef.current[type];
        if (section) {
          const { offsetTop, offsetHeight } = section;
          if (scrollPos >= offsetTop && scrollPos < offsetTop + offsetHeight) {
            setActiveType(type);
            break;
          }
        }
      }
    };
    scrollEl.addEventListener("scroll", handleScroll);
    return () => scrollEl.removeEventListener("scroll", handleScroll);
  }, [serviceTypes]);
  // }, [serviceTy/pes]);
  const autocompleteRef = useRef(null);

  const onLoad = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: google_places_key,
    libraries: ["places"],
  });
  const onPlaceChanged = (setFieldValue) => {
    if (!autocompleteRef.current) return;

    const place = autocompleteRef.current.getPlace();
    if (!place || !place.address_components) return;

    let street = place.formatted_address || "";
    let area = "";
    let state = "";
    let country = "";
    let lat = place.geometry?.location?.lat();
    let lng = place.geometry?.location?.lng();

    place.address_components.forEach((comp) => {
      const types = comp.types;

      if (types.includes("sublocality") || types.includes("locality")) {
        area = comp.long_name;
      }

      if (types.includes("administrative_area_level_1")) {
        state = comp.long_name;
      }

      if (types.includes("country")) {
        country = comp.short_name?.toLowerCase(); //  "in" / "ae"
      }
    });

    //  expected country based on currency
    const expectedCountry = currency === "INR" ? "in" : "ae";

    // console.log("Selected:", country, "Expected:", expectedCountry);

    // VALIDATION
    if (!country || country !== expectedCountry) {
      setLocationError(
        currency === "INR"
          ? "Please select a location within India"
          : "Please select a location within UAE"
      );

      setFieldValue("location", "");
      setFieldValue("area", "");
      setFieldValue("state", "");
      setFieldValue("lat", "");
      setFieldValue("lng", "");

      return;
    }

    //  CLEAR ERROR
    setLocationError("");

    //  SET VALUES
    setFieldValue("location", street);
    setFieldValue("area", area);
    setFieldValue("state", state);
    setFieldValue("country", country);
    setFieldValue("lat", lat);
    setFieldValue("lng", lng);
  };
  useEffect(() => {
    arrangeData(true);
  }, [initialServiceData]);

  useEffect(() => {
    setProviderSelected([]);
  }, [selectedService]);

  useEffect(() => {
    if (providerSelected?.length > 0) {
      setTimeSelect(providerSelected[0]?.start?.split("T")?.[1]);
    }
  }, [providerSelected]);

  useEffect(() => {
    arrangeData();
    getPrice();
  }, [serviceData]);

  const getStatusColors = (status) => {
    // Define color schemes for different statuses with requested light colors
    const statusColors = {
      //  Green - completed
      1: {
        bgColor: "#F2FFF0",
        // border: "1px solid #C6E4C6",

        // bgColor: "#fff",
        // border: "1px solid #C6E4C6",
        textColor: "#666600",
      },
      //Selected - Light blue
      2: {
        bgColor: "#FFF0FD",
        borderColor: "#92007E",
        textColor: "#92007E",
      },
      // Cancelled / red - Not avaiable
      3: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },
      4: {
        bgColor: "#28a745",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },
      // Break
      6: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },

      10: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },
      // Checked In (11) - Light blue
      11: {
        bgColor: "#FFF0FD",
        borderColor: "#92007E",
        textColor: "#92007E",
      },
      // Cancelled (14) - Light red
      14: {
        bgColor: "rgba(255, 204, 204, 0.5)",
        borderColor: "#CC0000",
        textColor: "#990000",
      },
      // No Show (15) - Light orange
      12: {
        bgColor: "F2F9FF",
        borderColor: "#037FE8",
        textColor: "#037FE8",
      },
      // Completed/Checked Out (15) - Light green
      15: {
        bgColor: "rgba(255, 255, 204, 0.5)",
        borderColor: "#CCCC00",
        textColor: "#666600",
      },
      // Default - Light gray
      default: {
        bgColor: "rgba(230, 230, 230, 0.5)",
        borderColor: "#999999",
        textColor: "#666666",
      },
    };

    return statusColors[status] || statusColors.default;
  };

  const appointments = filteredAppointments?.map((item) => {
    const colors = getStatusColors(item?.status);

    return {
      title: `${item.title?.trim()}`,
      search: item.title?.trim(),
      resourceId: item.title?.trim(),
      start: item?.start,
      end: item?.end,
      backgroundColor: colors.bgColor,
      borderColor: colors.borderColor,
      textColor: colors.textColor,
      extendedProps: {
        ...item,
      },
      // Optional: Add event class for additional styling
      className: `status-${item?.status || "default"}`,
    };
  });

  async function getAllServices() {
    try {
      setLoading(true);
      const response = await apicall.get(
        `get_ezp_service?partner_id=${partner_id}`
      );
      setLoading(false);
      if (response.success && response.data) {
        setServices(response.data);
        if (group_id) {
          getDataByID(response.data);
        } else {
          setSelectedService(response.data?.[0]);
          fetchServiceData(response.data?.[0]);

          setInitialValues({
            partner: partner_id,
            org_id: "",
            userName: "",
            phoneNumber: "",
            email: "",
            house_no: "",
            area: "",
            location: "",
            location_id: "",
            state: "",
            landmark: "",
            country: 1,
            lat: "",
            lng: "",
            status: "",
            payment: "",
          });
        }
      } else {
        setServices([]);
      }
    } catch (e) {
      console.log("e----", e);
    } finally {
      setLoading(false);
    }
  }

  async function getDataByID(allServicesData) {
    try {
      setLoading(true);
      const response = await apicall.get(
        `get_ezp_booking_by_id?group_id=${group_id}`
      );
      setLoading(false);
      if (response.success && response.data) {
        // console.log("response.data----", response.data);

        setExistingData(response?.data || []);
        let {
          customer_id,
          partner,
          org_id,
          user_name,
          email,
          phone_number,
          house_no,
          area,
          state,
          location,
          location_id,
          landmark,
          status,
          payment,
          lat,
          lng,
          service_id,
          service_date,
          service_time,
          discount,
          provider,
          display_booking_id,
          editable,
          additional_info,
          total_paid_amount,
          service_type_name,
        } = response.data[0];
        let d1 = {
          partner: partner,
          org_id: org_id,
          userName: user_name,
          phoneNumber: phone_number,
          email: email,
          house_no: house_no,
          area: area,
          location: location,
          location_id: location_id,
          state: state,
          landmark: landmark,
          country: 1,
          lat: lat,
          lng: lng,
          status: status,
          payment: payment,
        };
        setInitialValues(d1);
        setDateSelect(service_date);
        setTimeSelect(service_time);
        setDiscount(discount);
        setAdditionalNotes(additional_info);
        setPaidAmount(total_paid_amount);
        // Parse custom services from backend
        const customString = response.data[0]?.custom_items;

        if (customString) {
          const customArray = customString.split("||").map((item) => {
            const [name, amount] = item.split("::");

            return {
              id: Date.now() + Math.random(),
              name: name,
              amount: amount,
              isCustom: true,
            };
          });

          setPriceSection(customArray);
        }
        setPartner_id(partner);
        setDisplay_booking_id(display_booking_id);
        setEditable(editable);
        setUser_id(customer_id);
        setActiveType(service_type_name || "null");

        let providers = provider?.split(",")?.map((ele) => Number(ele));

        let selectedId;
        for (let i of allServicesData) {
          if (i.id === service_id) {
            selectedId = service_id;
            setSelectedService(i);
          }
        }
        let q1 = `getWokerAvailableSlots?date=${service_date}`;
        if (selectedId) {
          q1 += `&&service_id=${selectedId}`;
        }
        // setLoading(true);
        let getWorkerAvailable = await apicall.get(q1);

        let updatedData = getWorkerAvailable?.data || [];

        setInitialAppointments(getWorkerAvailable?.data || []);
        let dt = `${service_date}T${service_time}:00`;
        // console.log("dt---", dt);

        let p1 = [];
        for (let i of providers) {
          for (let j of updatedData) {
            if (i === j?.extendedProps?.provider_id && dt === j.start) {
              j.status = 2;
              p1.push(j);
            }
          }
        }
        // console.log("p1---", p1);
        setProviderSelected(p1);

        if (!editable) {
          let ans = updatedData.filter((i) => {
            let hours = timeSelect.split(":")[0];
            let mins = timeSelect.split(":")[1];

            let res = i.start.split("T")[1];
            // console.log(
            //   "res--",
            //   res,
            //   `${hours}:${mins}:00`,
            //   res === `${hours}:${mins}:00`
            // );
            return res === `${hours}:${mins}:00`;
            //   if (res === `${hours}:${mins}:00`) {
            //   i.start = i.start.split("T")[0] + "T" + `${hours}:${mins}:00`;
            // }
          });
          updatedData = ans;
        }

        for (let i of updatedData) {
          if (i.status === 2) {
            let date = new Date(i?.start);
            let t1 = maxTime / crewCount;
            date.setMinutes(date.getMinutes() + t1);
            i.end = convertWithoutTimseStamp(date);
          }
        }
        let u1 = cleanCrewSlots(updatedData);

        const result = u1.reduce(
          (acc, item) => {
            return {
              minStart: item.start < acc.minStart ? item.start : acc.minStart,
              maxEnd: item.end > acc.maxEnd ? item.end : acc.maxEnd,
            };
          },
          {
            minStart: u1[0].start,
            maxEnd: u1[0].end,
          }
        );
        let min1 = result?.minStart?.split("T")[1];
        let max1 = result?.maxEnd?.split("T")[1];
        setTimeRange({ startTime: min1, endTime: max1 });

        setFilteredAppointments(u1 || []);
      } else {
      }
    } catch (e) {
      console.log("e----", e);
    } finally {
      setLoading(false);
    }
  }

  function getPrice() {
    try {
      let prices = [];
      let total = 0;

      // Existing services total
      for (let eachData of serviceData) {
        if (eachData?.added) {
          let name = eachData.service_name + "- ";

          if (
            eachData.service_type_name &&
            eachData.service_type_name !== "null"
          ) {
            name += eachData.service_type_name + "- ";
          }

          name += eachData.service_offering_name;

          prices.push({
            name: name,
            service_id: eachData.service_id,
            service_name: eachData.service_name,
            service_type_id: eachData.service_type_id,
            service_type_name: eachData.service_type_name,
            service_offering_id: eachData.service_offering_id,
            service_offering_name: eachData.service_offering_name,
            amount: eachData.amount,
          });

          total = parseFloat(total) + parseFloat(eachData.amount || 0);
        }
      }

      //  ADD CUSTOM SERVICES TOTAL
      // Preserve custom services already in priceSection (from backend or UI)
      const existingCustomServices =
        priceSection?.filter((item) => item?.isCustom) || [];

      const customTotal = existingCustomServices.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
      );

      total = parseFloat(total) + parseFloat(customTotal || 0);

      const taxAmount = (parseFloat(total) * taxPercentage) / 100;
      if (prices?.length > 0 || customTotal > 0) {
        prices = [
          ...prices,
          {
            name: "Discount",
            amount: discount,
          },
          ...existingCustomServices,
          {
            name: `Tax (${taxPercentage}%)`,
            amount: taxAmount.toFixed(2),
          },
        ];

        let t1 = parseFloat(total) + taxAmount - parseFloat(discount || 0);

        prices.push({
          name: "Total",
          amount: parseFloat(t1).toFixed(2),
        });
      }

      setPriceSection(prices);
    } catch (e) {
      console.log("e-----", e);
    }
  }

  async function arrangeData(d1) {
    let g1 = serviceData.reduce((acc, item) => {
      // console.log("acc--", acc);
      let { service_type_name } = item;
      // console.log(service_type_name);
      if (!acc[service_type_name]) acc[service_type_name] = [];

      if (d1) item.added = false;
      acc[service_type_name].push(item);
      return acc;
    }, {});

    setServiceTypes(Object.keys(g1));
    setGroupedData(g1);
  }

  useEffect(() => {
    setActiveType(serviceTypes[0] || "null");
  }, []);

  useEffect(() => {
    const initializeData = async () => {
      try {
        await Promise.all([
          fetchCountries(),
          getBookingStatus(),
          getPaymentStatus(),
        ]);
      } catch (error) {
        console.error("Error initializing data:", error);
        toast.error("Failed to initialize form data");
      }
    };

    initializeData();
  }, []);

  const fetchServiceData = async (data, partnerID = 1) => {
    try {
      if (data?.service_id) {
        let p1 = partner_id ? partner_id : partnerID;
        setLoading(true);
        const response = await apicall.get(
          `offeringFromService?service_id=${data?.service_id}&&is_partner=true&&partner_id=${p1}`
        );
        setLoading(false);

        // console.log("existingData----->>>>", existingData);
        let copyResponse;
        if (response?.data) {
          copyResponse = JSON.parse(JSON.stringify(response?.data));
        }

        let offering_id = [];
        let type_name;

        if (response.success && copyResponse) {
          for (let i of existingData) {
            for (let j of copyResponse) {
              if (i.service_offering_id === j.service_offering_id) {
                // console.log("is there-----");
                j.added = true;
                if (!offering_id.includes(i.service_offering_id)) {
                  j.amount = Number(i.price);
                  offering_id.push(i.service_offering_id);
                }
                break;
              }
            }
          }
          // console.log("offering_id---", offering_id);
          // console.log("copyResponse---", copyResponse);

          let c1 = copyResponse?.map((ele) => {
            if (offering_id.includes(ele?.service_offering_id)) {
              if (!type_name) {
                type_name = ele?.service_type_name;
                setActiveType(ele?.service_type_name);
              }

              return { ...ele, added: true };
            } else {
              return { ...ele, added: false };
            }
          });

          let sumTime = 0;
          for (let i of copyResponse) {
            if (i?.added) {
              let t1 = i?.time_required + i?.buffer;
              sumTime += t1;
            }
          }
          setMaxTime(sumTime);

          if (!type_name) {
            setActiveType(
              copyResponse[0]?.service_type_name
                ? copyResponse[0]?.service_type_name
                : "null"
            );
          }

          setServiceData(c1);
        } else {
          setServiceData([]);
        }
      }
    } catch (error) {
      console.log("err---", error);
      toast.error("Failed to fetch service offerings....");
      setInitialServiceData([]);
      setServiceData([]);
    } finally {
      setLoading(false);
    }
  };
  const crewCount = providerSelected?.length || 1;

  const serviceDuration = maxTime / 60;
  // groupedData?.[activeType]?.find((d) => d.added)?.time_required / 60 || 0;

  const durationPerCleaner = maxTime / crewCount;
  // crewCount > 0 ? Math.ceil((serviceDuration * 60) / crewCount) : 0;

  const totalReservedHours = maxTime / 60;
  // crewCount > 0 ? (crewCount * serviceDuration).toFixed(2) : 0;

  const fetchPartners = async () => {
    try {
      const response = await apicall.get("partners");
      setPartners(response.data);

      if (!group_id) {
        setPartner_id(response?.data[0]?.id);
        setInitialValues({
          partner: response?.data[0]?.id,
          org_id: "",
          userName: "",
          phoneNumber: "",
          email: "",
          house_no: "",
          area: "",
          location: "",
          location_id: "",
          state: "",
          landmark: "",
          country: 1,
          lat: "",
          lng: "",
          status: "",
          payment: "",
        });
      }
    } catch (error) {
      console.error("Error fetching fetchPartners:", error);
      toast.error("Failed to fetch fetchPartners");
    }
  };

  const getBookingStatus = async () => {
    try {
      const response = await apicall.get("get_ezp_booking_status");

      if (response.success) {
        setBookingStatus(response.data);
      } else {
        setBookingStatus([]);
      }
    } catch (error) {
      console.error("Error fetching Booking Status:", error);
      toast.error("Failed to fetch Booking Status:");
    }
  };

  const getRecentBookings = async (ph_number) => {
    try {
      const response = await apicall.get(
        `getRecentBookings/${ph_number}/${vendor_id}`
      );

      if (response.success && response.data) {
        setRecentBookings(response.data || []);
      } else {
        setRecentBookings([]);
      }
    } catch (error) {
      console.error("Error fetching Booking Status:", error);
      toast.error("Failed to fetch Booking Status:");
    }
  };

  const getPaymentStatus = async () => {
    try {
      const response = await apicall.get("get_ezp_payment_status");
      if (response.success) {
        setPaymentStatus(response.data);
      } else {
        setPaymentStatus([]);
      }
    } catch (error) {
      console.error("Error fetching Booking Status:", error);
      toast.error("Failed to fetch Booking Status:");
    }
  };

  const fetchCountries = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await apicall.get("country", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.success) {
        const countriesData = Array.isArray(response.data)
          ? response.data
          : response.data?.countries || [];

        setCountries(countriesData);

        // Find UAE in the countries list
        // const uaeCountry = countriesData.find(
        //   (country) =>
        //     country.name.toLowerCase() === "united arab emirates" ||
        //     country.name.toLowerCase() === "uae"
        // );

        // If UAE is found, set it as default
        // if (uaeCountry) {
        //   // setInitialValues((prev) => ({
        //   //   ...prev,
        //   //   country: uaeCountry.country_id.toString(),
        //   // }));
        //   // Fetch states for UAE
        //   fetchStates(uaeCountry.country_id.toString());
        // } else if (countriesData.length > 0) {
        //   // Fallback to first country if UAE not found
        //   // setInitialValues((prev) => ({
        //   //   ...prev,
        //   //   country: countriesData[0].country_id.toString(),
        //   // }));
        //   fetchStates(countriesData[0].country_id.toString());
        // }
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      toast.error("Failed to fetch countries");
    }
  };

  const fetchStates = async (countryId1) => {
    try {
      // console.log("countryId----", countryId);
      let countryId = currency === "INR" ? 2 : 1;
      const token = localStorage.getItem("token");
      const response = await apicall.get(`state/${countryId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.success && response.data) {
        setStates(response.data);
      } else {
        setStates([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      toast.error("Failed to fetch states");
      setStates([]);
    }
  };

  const handleCountryChange = (e, setFieldValue) => {
    const countryId = e.value;

    setFieldValue("country", countryId);
    if (countryId) {
      fetchStates(countryId);
      // Reset state and city when country changes
      // setStates([]);
      // setCities([]);
      // setFieldValue("state", "");
      // setFieldValue("area", "");
    } else {
      // setStates([]);
      // setCities([]);
    }
  };
  useEffect(() => {
    if (initialValues.country) {
      fetchStates(initialValues.country);
    }
  }, [initialValues.country]);
  const handleStateChange = (e, setFieldValue) => {
    const stateId = e.target.value;

    setFieldValue("state", stateId);
    if (stateId) {
      // fetchCities(stateId);
      // Reset city when state changes
      // setCities([]);
      // setFieldValue("city", "");
    } else {
      // setCities([]);
    }
  };

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const get_user_details = async (ph_number, setFieldValue) => {
    const response = await apicall.get(
      `ezp_get_users_details/${ph_number}/${vendor_id}`
    );

    // console.log("first---response---", response);

    if (response.status === 200 && response.data.length > 0) {
      const user = response.data[0];
      const fullName = `${user.first_name} ${user.middle_name || ""} ${
        user.last_name || ""
      }`.trim();
      // const age = calculateAge(user.dob);
      const gender =
        user.gender === null
          ? "Not Available"
          : user.gender === 1
          ? "Male"
          : "Female";

      setUser_id(user?.id || 0);

      // Update form values using Formik's setFieldValue
      setFieldValue("userName", fullName);
      setFieldValue("email", user?.email || "");
      setFieldValue("house_no", user?.house_no || "");
      setFieldValue("area", user?.area || "");
      setFieldValue("landmark", user?.landmark || "");
      setFieldValue("state", user?.state || "");
      setFieldValue("location", user?.location || "");
      setFieldValue("state", user?.state || "");
      // setFieldValue("age", age.toString());
      setFieldValue("lat", user?.lat || "");
      setFieldValue("lng", user?.lng || "");
      setFieldValue("gender", gender);
      setFieldValue("location_id", user?.location_id || "");

      let d1 = {
        house_no: user?.house_no || "",
        area: user?.area || "",
        location: user?.location || "",
        state: user?.state || "",
        landmark: user?.landmark || "",
        lat: user?.lat || "",
        lng: user?.lng || "",
      };
      setFirstLocation(d1);

      // setSelectedUserId(user.id);

      // // Also update formData state for consistency
      // setFormData((prev) => ({
      //   ...prev,
      //   userName: fullName,
      //   age: age.toString(),
      //   gender: gender,
      // }));
    } else {
      setFieldValue("userName", "");
      setFieldValue("age", "");
      setFieldValue("gender", "");
    }
  };

  const debouncedCheckUserExists = useCallback(
    debounce(async (field, value, setFieldValue, setFieldError) => {
      try {
        get_user_details(value, setFieldValue);
        getRecentBookings(value, setFieldValue);
      } catch (error) {
        console.error(`Error in debounced check for ${field}:`, error);
      }
    }, 500),
    []
  );

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      // console.log("submitting....");
      // console.log(values, "values");
      let flag = true;

      if (!services || services.length === 0) {
        toast.error(
          "Please add Service Type and Offerings from Admin Setup before booking."
        );
        return;
      }

      if (!serviceTypes || serviceTypes.length === 0) {
        toast.error("Please configure Service Offerings before proceeding.");
        return;
      }
      let addedService = serviceData?.filter((ele) => ele?.added);
      if (addedService?.length === 0) {
        toast.error("Select Service Offerings to proceed");
        flag = false;
      }

      if (providerSelected?.length === 0) {
        toast.error("Select Time and Crew");
        flag = false;
      }

      if (!flag) {
        return;
      }

      // console.log("priceSection-----", priceSection);

      let d1 = {
        house_no: values?.house_no || "",
        area: values?.area || "",
        location: values?.location || "",
        state: values?.state || "",
        landmark: values?.landmark || "",
        lat: values?.lat || "",
        lng: values?.lng || "",
      };
      // setFirstLocation(d1);
      // console.log("d1------", d1, firstLocation);

      let isLocationChanged = false;
      if (JSON.stringify(d1) !== JSON.stringify(firstLocation)) {
        isLocationChanged = true;
      }

      let providers = providerSelected?.map(
        (ele) => ele?.extendedProps?.provider_id
      );

      values.existingUserId = user_id;
      values.editable = editable ? 1 : 0;

      values.date = dateSelect;
      values.isLocationChanged = isLocationChanged;
      let t1 = providerSelected[0]?.start?.split("T")[1]?.split(":") || "";
      t1 = t1[0] + ":" + t1[1];
      values.time = t1;
      values.serviceData = serviceData;
      values.priceSection = priceSection;
      values.providers = providers?.join(", ");
      values.group_id = group_id;
      values.additional_notes = additionalNotes;
      values.paid_amount = paidAmount;
      // console.log("values---", values);
      setModelData(values);

      setLoading(true);
      const response = await apicall.post(values, "create_ezp_booking");
      // console.log("response-0>>", response);
      values.booking_id = response?.booking_id || 1;
      setModelData(values);
      setLoading(false);
      setShowOrderConf(true);
    } catch (e) {
      console.log("err---", e);
    }
  };

  const addOffering = (data) => {
    try {
      // console.log("data-----", data);
      let t1 = data?.time_required + data?.buffer;

      // if (t1 > maxTime) {
      //   setMaxTime(t1);
      // }
      let { service_offering_id } = data;
      let copyServiceData = JSON.parse(JSON.stringify(serviceData));
      for (let eachdata of copyServiceData) {
        if (eachdata?.service_offering_id === service_offering_id) {
          eachdata.added = !eachdata.added;
          break;
        }
      }

      let sumTime = 0;
      for (let i of copyServiceData) {
        if (i?.added) {
          let t1 = i?.time_required + i?.buffer;
          sumTime += t1;
        }
      }
      setMaxTime(sumTime);
      setServiceData(copyServiceData);
    } catch (e) {
      console.log("err----", e);
    }
  };
  const totalItem = priceSection?.find((item) => item.name === "Total");
  const totalAmount = Number(totalItem?.amount || 0);

  const balanceDue = totalAmount - Number(paidAmount || 0);

  function priceChange(value, data) {
    try {
      let copyServiceData = JSON.parse(JSON.stringify(serviceData));

      for (let eachData of copyServiceData) {
        if (eachData.service_offering_id === data?.service_offering_id) {
          eachData.amount = value;
        }
      }
      if (data?.name === "Discount") {
        setDiscount(value);
      }

      setServiceData(copyServiceData);
    } catch (e) {
      console.log("err-----", e);
    }
  }
  function deleteCustomItem(index) {
    const copy = [...priceSection];

    //  remove item
    copy.splice(index, 1);

    //  update UI immediately
    setPriceSection(copy);

    //  temporarily override priceSection for calculation
    const existingCustomServices = copy.filter((item) => item?.isCustom) || [];

    //  manual trigger (same logic as getPrice but with updated copy)
    try {
      let prices = [];
      let total = 0;

      // services
      for (let eachData of serviceData) {
        if (eachData?.added) {
          let name = eachData.service_name + "- ";

          if (
            eachData.service_type_name &&
            eachData.service_type_name !== "null"
          ) {
            name += eachData.service_type_name + "- ";
          }

          name += eachData.service_offering_name;

          prices.push({
            name,
            amount: eachData.amount,
          });

          total += Number(eachData.amount || 0);
        }
      }

      //  use UPDATED custom items
      const customTotal = existingCustomServices.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
      );

      total += customTotal;

      const taxAmount = (total * taxPercentage) / 100;

      let finalTotal = total - Number(discount || 0);

      prices = [
        ...prices,
        { name: "Discount", amount: discount },
        ...existingCustomServices,
        {
          name: `Tax (${taxPercentage}%)`,
          amount: taxAmount.toFixed(2),
        },
      ];

      finalTotal += taxAmount;

      prices.push({
        name: "Total",
        amount: finalTotal.toFixed(2),
      });

      setPriceSection(prices);
    } catch (e) {
      console.log(e);
    }
  }
  function addCustomService() {
    const copy = [...priceSection];

    const taxIndex = copy.findIndex((item) =>
      item.name?.toLowerCase().includes("tax")
    );

    const newRow = {
      name: "",
      amount: "",
      isCustom: true,
      id: Date.now(),
    };

    if (taxIndex !== -1) {
      copy.splice(taxIndex, 0, newRow); //  insert BEFORE tax
    } else {
      copy.push(newRow);
    }

    setPriceSection(copy);
  }

  function customNameChange(value, index) {
    const copy = [...priceSection];
    copy[index].name = value;
    setPriceSection(copy);
  }
  function customPriceChange(value, index) {
    const copy = [...priceSection];
    copy[index].amount = value;
    setPriceSection(copy);

    getPrice();
  }
  const onHide = () => {
    // console.log("close....");
    setShowCalender(false);
    flagCount.current = 0;
  };

  function convertWithoutTimseStamp(date) {
    try {
      const year = date?.getFullYear();
      const month = String(date?.getMonth() + 1).padStart(2, "0");
      const day = String(date?.getDate()).padStart(2, "0");
      const hours = String(date?.getHours()).padStart(2, "0");
      const minutes = String(date?.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}:00`;
    } catch (e) {
      console.log("err---", date, e);
    }
  }

  const cleanCrewSlots = (slots) => {
    const grouped = {};

    // Step 1: Group by provider_id
    slots.forEach((slot) => {
      const id = slot.extendedProps.provider_id;
      if (!grouped[id]) grouped[id] = [];
      grouped[id].push(slot);
    });

    let result = [];

    // Step 2: Process each crew separately
    Object.values(grouped).forEach((group) => {
      const bookedSlots = group.filter((s) => s.status === 2);

      const cleaned = group.filter((slot) => {
        // keep booked slots
        if (slot.status === 2) return true;

        // remove overlap only within same crew
        const isOverlapping = bookedSlots.some((booked) => {
          return (
            new Date(slot.start) < new Date(booked.end) &&
            new Date(slot.end) > new Date(booked.start)
          );
        });

        return !isOverlapping;
      });

      result.push(...cleaned);
    });

    return result;
  };

  const handleAppointmentClick = (appointment, currentDate) => {
    if ([3, 6].includes(appointment?.details?.status)) {
      // console.log("booked...or break...");
      return;
    }

    let copyFilterData = JSON.parse(JSON.stringify(filteredAppointments));
    let alreadyBookedSlots = copyFilterData.filter(
      (ele) => ele.status === 3 || ele?.status === 6
    );

    // console.log("alreadyBookedSlots-------", alreadyBookedSlots);
    // console.log("appointment-------", appointment);

    setDateSelect(appointment?.details?.start?.split("T")?.[0]);
    let agentAssigned = [];
    let inSuffiientTime = false;

    if (appointment?.details?.status !== 3) {
      copyFilterData?.forEach((eachdata, idx) => {
        if ([3, 6].includes(eachdata?.status)) {
          // continue;
        } else if (
          appointment?.details?.start !== eachdata.start &&
          appointment?.details?.end !== eachdata.end
        ) {
          eachdata.status = 1;
          let date = new Date(eachdata?.start);
          date.setMinutes(date.getMinutes() + 30);
          eachdata.end = date;
        } else if (
          eachdata?.extendedProps?.provider_id ===
            appointment?.details?.extendedProps?.provider_id &&
          eachdata?.start === appointment?.details?.start &&
          eachdata.status === 2
        ) {
          // console.log("not there.......");
          eachdata.status = 1;
          let date = new Date(eachdata?.start);
          date.setMinutes(date.getMinutes() + 30);
          eachdata.end = date;
        } else if (
          eachdata?.extendedProps?.provider_id ===
            appointment?.details?.extendedProps?.provider_id &&
          eachdata?.start === appointment?.details?.start &&
          eachdata.status === 1
        ) {
          // console.log("available....", alreadyBookedSlots);
          // eachdata.status = 2;

          let flag = true;
          let s1 = new Date(eachdata?.start);
          s1.setMinutes(s1.getMinutes() + maxTime);
          let h1 = maxTime / 60;

          for (let i of alreadyBookedSlots) {
            let e1 = new Date(i?.start);
            let e2 = new Date(i?.end);
            // console.log("s1,e1,e2------", s1, e1, e2);
            if (
              s1 >= e1 &&
              s1 <= e2 &&
              i?.extendedProps?.provider_id ===
                eachdata?.extendedProps?.provider_id
            ) {
              flag = false;
              inSuffiientTime = true;
              setCalenderMessage(
                `Not enough availability.This slot requires a full ${h1}-hour window. Please select a different start time.`
              );
              break;
            }
          }

          let a1 = new Date(appointment?.details?.start);
          a1.setMinutes(a1.getMinutes() + maxTime);

          const maxEnd = copyFilterData
            .filter(
              (e) =>
                e.extendedProps.provider_id ===
                appointment?.details?.extendedProps?.provider_id
            )
            .map((e) => new Date(e.end))
            .reduce((max, curr) => (curr > max ? curr : max));

          // console.log(
          //   "maxEnd------ appointment?.details?.extendedProps?.provider_id---",
          //   appointment?.details?.extendedProps?.provider_id,
          //   maxEnd
          // );

          // console.log("a1----", a1);

          if (a1 > maxEnd) {
            flag = false;
            inSuffiientTime = true;
            setCalenderMessage(
              `Not enough availability.This slot requires a full ${h1}-hour window. Please select a different start time.`
            );
          }

          if (flag) eachdata.status = 2;
        }

        if (eachdata?.status === 2) {
          let date = new Date(eachdata?.start);
          date.setMinutes(date.getMinutes() + maxTime);
          // eachdata.end = date;

          // eachdata.end = convertWithoutTimseStamp(date);

          // console.log("eachData--", eachdata, maxTime);
          agentAssigned.push(eachdata);
        }
      });
    }

    let initial1 = JSON.parse(JSON.stringify(initialAppointments));
    // console.log("before intital----", initialAppointments, initial1);
    // console.log("inti-", initial1, copyFilterData);

    for (let x = 0; x < initialAppointments.length; x++) {
      let i = initial1[x];

      for (let j of copyFilterData) {
        if (
          j.status === 2 &&
          i.start === j.start &&
          i.extendedProps?.provider_id === j.extendedProps?.provider_id
        ) {
          initial1[x] = JSON.parse(JSON.stringify(j)); // <-- correctly updates array
          break;
        }
      }
    }

    // console.log("after intital----", initial1);

    setProviderSelected(agentAssigned);

    let updated = [];

    for (let i of initial1) {
      let flag = true;
      if ([2, 3].includes(i.status)) {
        updated?.push(i);
      } else {
        for (let j of agentAssigned) {
          let s1 = convertWithoutTimseStamp(new Date(i.start));
          let e1 = convertWithoutTimseStamp(new Date(i.end));
          let p1 = i.extendedProps?.provider_id;
          let s2 = convertWithoutTimseStamp(new Date(j.start));
          let e2 = convertWithoutTimseStamp(new Date(j.end));
          let p2 = j.extendedProps?.provider_id;
          if (p1 === p2 && s1 >= s2 && e1 <= e2) {
            flag = false;
            break;
          }
        }
        if (flag) {
          if (editable) {
            updated?.push(i);
          } else {
            let hours = timeSelect.split(":")[0];
            let mins = timeSelect.split(":")[1];

            let res = i.start.split("T")[1];

            if (res === `${hours}:${mins}:00`) {
              updated?.push(i);
            }
          }
        }
      }
    }

    // console.log("updated--", updated);

    for (let i of updated) {
      if (i.status === 2) {
        let date = new Date(i?.start);
        let t1 = maxTime / agentAssigned?.length;
        date.setMinutes(date.getMinutes() + t1);
        i.end = convertWithoutTimseStamp(date);
      }
    }

    let u1 = cleanCrewSlots(updated);

    const result = u1.reduce(
      (acc, item) => {
        return {
          minStart: item.start < acc.minStart ? item.start : acc.minStart,
          maxEnd: item.end > acc.maxEnd ? item.end : acc.maxEnd,
        };
      },
      {
        minStart: u1[0].start,
        maxEnd: u1[0].end,
      }
    );
    let min1 = result?.minStart?.split("T")[1];
    let max1 = result?.maxEnd?.split("T")[1];
    setTimeRange({ startTime: min1, endTime: max1 });

    setFilteredAppointments(u1);
  };

  const datesSet = (dateInfo) => {
    try {
      let d1 = dateInfo.startStr?.split("T")?.[0];

      getWorkerAvailableSlots(d1);

      if (![0, 1].includes(flagCount.current)) {
        // console.log("adteIfo---", dateInfo);
      }
      flagCount.current += 1;
    } catch (e) {
      console.log("err---", e);
    }
  };

  // console.log("dateSelect-----", dateSelect);

  const getWorkerAvailableSlots = async (selecDate) => {
    try {
      // console.log("selecDate----", selecDate);
      let d1 = new Date(selecDate);
      d1 = d1.toLocaleDateString("en-GB").split(/[\/\-\.]/);
      d1 = `${d1[2]}-${d1[1]}-${d1[0]}`;
      // console.log("d1---", d1);
      // setDateSelect(d1);
      setLoading(true);
      let q1 = `getWokerAvailableSlots?date=${d1}`;

      // console.log("selectedService---", selectedService);
      if (
        selectedService?.service_id &&
        selectedService?.service_id !== "undefined"
      ) {
        q1 += `&&service_id=${selectedService?.service_id}`;
      }
      let getWorkerAvailable = await apicall.get(q1);

      let updatedData =
        JSON.parse(JSON.stringify(getWorkerAvailable?.data)) || [];

      // console.log("1st.......", getWorkerAvailable?.data);

      setInitialAppointments(getWorkerAvailable?.data || []);

      for (let i of providerSelected) {
        for (let j of updatedData) {
          if (
            i?.start === j?.start &&
            i.extendedProps.provider_id === j.extendedProps.provider_id
          ) {
            j.status = 2;
            let date = new Date(j?.start);
            date.setMinutes(date.getMinutes() + maxTime);
            j.end = date;
          }
        }
      }

      let updated = [];

      for (let i of updatedData) {
        let flag = true;
        if ([2, 3].includes(i.status)) {
          updated?.push(i);
        } else {
          for (let j of providerSelected) {
            let s1 = new Date(i.start);
            let e1 = new Date(i.end);
            let p1 = i.extendedProps?.provider_id;

            let s2 = new Date(j.start);
            let e2 = new Date(j.end);
            let p2 = j.extendedProps?.provider_id;

            if (p1 === p2 && s1 >= s2 && e1 <= e2) {
              flag = false;
              break;
            }
          }
          if (flag) {
            if (editable) {
              updated?.push(i);
            } else {
              let hours = timeSelect.split(":")[0];
              let mins = timeSelect.split(":")[1];

              let res = i.start.split("T")[1];
              // console.log(
              //   "res--",
              //   res,
              //   `${hours}:${mins}:00`,
              //   res === `${hours}:${mins}:00`
              // );
              if (res === `${hours}:${mins}:00`) {
                updated?.push(i);
              }
            }
          }
        }
      }

      // console.log("2nd-------", getWorkerAvailable?.data);

      for (let i of updated) {
        if (i.status === 2) {
          let date = new Date(i?.start);
          let t1 = maxTime / crewCount;
          date.setMinutes(date.getMinutes() + t1);
          i.end = convertWithoutTimseStamp(date);
        }
      }

      let u1 = cleanCrewSlots(updated);

      const result = u1.reduce(
        (acc, item) => {
          return {
            minStart: item.start < acc.minStart ? item.start : acc.minStart,
            maxEnd: item.end > acc.maxEnd ? item.end : acc.maxEnd,
          };
        },
        {
          minStart: u1[0].start,
          maxEnd: u1[0].end,
        }
      );
      let min1 = result?.minStart?.split("T")[1];
      let max1 = result?.maxEnd?.split("T")[1];
      setTimeRange({ startTime: min1, endTime: max1 });

      setFilteredAppointments(u1 || []);
      setShowCalender(true);
      close();
    } catch (e) {
      console.log("err--", e);
    }
  };

  // console.log("filteredAppointments--------------", filteredAppointments);

  //function call to convert date to 12 hours
  const convertTo12Hour = (time24) => {
    if (!time24) return "";
    const [hourStr, minute] = time24?.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // Convert 0 to 12
    return `${hour}:${minute} ${ampm}`;
  };

  const onHideOrderConf = () => {
    setShowOrderConf(false);
    navigate("/dashboard");
  };

  if (loading && isEditing) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "400px" }}
      >
        <Spinner animation="border" variant="danger" />
      </div>
    );
  }

  const formatDateDisplay = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  function close() {
    setOpen(false);
  }

  const passes = () => {
    console.log("Pass...");
  };

  return (
    <>
      <RotateDevicePopup />
      <div onClick={close}>
        <div className="d-flex justify-content-between">
          {group_id ? (
            <h4>Edit Booking - {display_booking_id}</h4>
          ) : (
            <h4>New Booking</h4>
          )}
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setValues,
            setFieldError,
            setFieldTouched,
          }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <div className="mt-4 mb-2">
                  <Accordion
                    defaultActiveKey={!group_id ? ["0"] : ["1"]}
                    alwaysOpen
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Customer Information</Accordion.Header>
                      <Accordion.Body>
                        <div className="mb-4">
                          {/* <h6 className="mb-4 section-heading">Personal Details</h6> */}
                          <Row className="mb-4">
                            <Col md={4} className="mb-2">
                              <Form.Group>
                                <Form.Label>Profile</Form.Label>
                                {/* <Form.Select
                              name="partner"
                              value={values.partner}
                              onChange={(e) => {
                                handleChange(e);
                                setPartner_id(e.target.value);
                                fetchServiceData(
                                  selectedService,
                                  e.target.value
                                );
                              }}
                              onBlur={handleBlur}
                              isInvalid={touched.partner && errors.partner}
                              className={`form-input ${
                                values.partner === "" ? "placeholder-style" : ""
                              }`}
                              style={{
                                height: "40px",
                                backgroundColor: "white",
                                border:
                                  touched.partner && errors.partner
                                    ? "1px solid #dc3545"
                                    : "1px solid #E9ECEF",
                              }}
                            >
                              <option value="">Select Profile</option>
                              {partners?.map((partner) => (
                                <option key={partner?.id} value={partner?.id}>
                                  {partner?.partner_name}
                                </option>
                              ))}
                            </Form.Select> */}
                                <Dropdown
                                  name="partner"
                                  value={values.partner}
                                  options={partners?.map((p) => ({
                                    label: p.partner_name,
                                    value: p.id,
                                  }))}
                                  placeholder="Select Profile"
                                  onChange={(e) => {
                                    handleChange({
                                      target: {
                                        name: "partner",
                                        value: e.value,
                                      },
                                    });
                                    setPartner_id(e.value);
                                    fetchServiceData(selectedService, e.value);
                                  }}
                                  onBlur={handleBlur}
                                  className={`w-100 ${
                                    touched.partner && errors.partner
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  disabled={!editable}
                                  // panelClassName="partner-dropdown-panel"
                                  // itemClassName="partner-dropdown-item"
                                  style={{
                                    height: "40px",
                                    border:
                                      touched.partner && errors.partner
                                        ? "1px solid #dc3545"
                                        : "1px solid #E9ECEF",
                                  }}
                                />

                                {touched.partner && errors.partner && (
                                  <div className="invalid-feedback d-block">
                                    {errors.partner}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group>
                                <Form.Label>
                                  Mobile Number
                                  <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <PhoneInput
                                  country={currency === "INR" ? "in" : "ae"}
                                  // country={phoneCountryCode}
                                  onlyCountries={["ae", "in"]}
                                  value={values.phoneNumber}
                                  disabled={!editable}
                                  onChange={(value) => {
                                    const cleanedValue = value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    setFieldValue("phoneNumber", cleanedValue);
                                    setFieldTouched("phoneNumber", true, false);

                                    // Only check for user existence if the number is valid
                                    if (cleanedValue.length >= 12) {
                                      debouncedCheckUserExists(
                                        "phoneNumber",
                                        cleanedValue,
                                        setFieldValue,
                                        setFieldError
                                      );
                                    }
                                  }}
                                  inputStyle={{
                                    width: "100%",
                                    height: "40px",
                                    backgroundColor: "white",
                                    borderColor:
                                      touched.phoneNumber && errors.phoneNumber
                                        ? "#dc3545"
                                        : "#E9ECEF",
                                  }}
                                  inputProps={{
                                    name: "phoneNumber",
                                    // required: true,
                                  }}
                                />
                                {touched.phoneNumber && errors.phoneNumber && (
                                  <div className="invalid-feedback d-block">
                                    {errors.phoneNumber}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group>
                                <Form.Label>Origin Booking ID</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="org_id"
                                  placeholder="Enter original booking ID..."
                                  value={values.org_id}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled={!editable}
                                  isInvalid={touched.org_id && errors.org_id}
                                  className="form-input"
                                  style={{ height: "40px" }}
                                />
                                {touched.org_id && errors.org_id && (
                                  <div className="invalid-feedback d-block">
                                    {errors.org_id}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group>
                                <Form.Label>
                                  Customer Name
                                  <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="userName"
                                  placeholder="Enter Customer Name..."
                                  value={values.userName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled={!editable}
                                  isInvalid={
                                    touched.userName && errors.userName
                                  }
                                  className="form-input"
                                />
                                {touched.userName && errors.userName && (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.userName}
                                  </Form.Control.Feedback>
                                )}
                              </Form.Group>
                            </Col>

                            <Col md={4}>
                              <Form.Group>
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control
                                  type="email"
                                  name="email"
                                  placeholder="Enter email address"
                                  value={values.email}
                                  disabled={!editable}
                                  onChange={(e) => {
                                    handleChange(e);
                                    const value = e.target.value;
                                    setFieldTouched("email", true, false);
                                    if (
                                      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                                        value
                                      )
                                    ) {
                                      setFieldError(
                                        "email",
                                        "Invalid email format"
                                      );
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  isInvalid={touched.email && errors.email}
                                  className="form-input"
                                />
                                {touched.email && errors.email && (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                  </Form.Control.Feedback>
                                )}
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                        <div className="mb-4">
                          <h6 className="section-heading">Address</h6>
                          <Row className="g-3">
                            <Col md={4}>
                              <Form.Group>
                                <Form.Label>
                                  Address{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Form.Label>

                                <div style={{ position: "relative" }}>
                                  {isLoaded && (
                                    <Autocomplete
                                      onLoad={onLoad}
                                      onPlaceChanged={() =>
                                        onPlaceChanged(setFieldValue)
                                      }
                                      options={{
                                        componentRestrictions: {
                                          country:
                                            currency === "INR" ? "in" : "ae",
                                        },
                                      }}
                                    >
                                      <Form.Control
                                        type="text"
                                        name="location"
                                        placeholder="Search address"
                                        value={values.location}
                                        onChange={handleChange}
                                        className="form-input"
                                      />
                                    </Autocomplete>
                                  )}

                                  {values.location && (
                                    <span
                                      onClick={() => {
                                        setFieldValue("location", "");
                                        setFieldValue("area", "");
                                        setFieldValue("state", "");
                                        setFieldValue("lat", "");
                                        setFieldValue("lng", "");
                                      }}
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                      }}
                                    >
                                      ✖
                                    </span>
                                  )}
                                  {locationError && (
                                    <div
                                      className="text-danger mt-1"
                                      style={{ fontSize: "13px" }}
                                    >
                                      {locationError}
                                    </div>
                                  )}
                                </div>
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group>
                                <Form.Label>
                                  House / Flat / Building No
                                  <span style={{ color: "red" }}>*</span>
                                </Form.Label>

                                <Form.Control
                                  type="text"
                                  name="house_no"
                                  placeholder="Enter house / flat / building no"
                                  value={values.house_no}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled={!editable}
                                  isInvalid={
                                    touched.house_no && errors.house_no
                                  }
                                  className="form-input"
                                  style={{ height: "40px" }}
                                />

                                {touched.house_no && errors.house_no && (
                                  <div className="invalid-feedback d-block">
                                    {errors.house_no}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group>
                                <Form.Label>
                                  Area<span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="area"
                                  placeholder="Enter area details..."
                                  value={values.area}
                                  onChange={handleChange}
                                  disabled={!editable}
                                  onBlur={handleBlur}
                                  isInvalid={touched.area && errors.area}
                                  className="form-input"
                                  style={{ height: "40px" }}
                                />
                                {touched.area && errors.area && (
                                  <div className="invalid-feedback d-block">
                                    {errors.area}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            {/* <Col md={4}>
                              <Form.Group>
                                <Form.Label>
                                  Location
                                  <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="location"
                                  placeholder="Enter location details..."
                                  value={values.location}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled={!editable}
                                  isInvalid={
                                    touched.location && errors.location
                                  }
                                  className="form-input"
                                  style={{ height: "40px" }}
                                />
                                {touched.location && errors.location && (
                                  <div className="invalid-feedback d-block">
                                    {errors.location}
                                  </div>
                                )}
                              </Form.Group>
                            </Col> */}

                            <Col md={4}>
                              <Form.Group>
                                <Form.Label>
                                  {currency === "INR" ? "State" : "Emirate"}
                                  <span
                                    style={{ color: "red", fontSize: "1rem" }}
                                  >
                                    *
                                  </span>
                                </Form.Label>
                                {/* <Form.Select
                              name="state"
                              value={values.state}
                              onChange={(e) =>
                                handleStateChange(e, setFieldValue)
                              }
                              onBlur={handleBlur}
                              isInvalid={touched.state && errors.state}
                              className={`form-input ${
                                values.state === "" ? "placeholder-style" : ""
                              }`}
                              style={{
                                height: "40px",
                                backgroundColor: "white",
                                border:
                                  touched.state && errors.state
                                    ? "1px solid #dc3545"
                                    : "1px solid #E9ECEF",
                              }}
                            >
                              <option value="">Select Emirate</option>
                              {states.map((state) => (
                                <option key={state.name} value={state.name}>
                                  {state.name}
                                </option>
                              ))}
                            </Form.Select> */}
                                <Dropdown
                                  name="state"
                                  value={values.state}
                                  options={states?.map((s) => ({
                                    label: s.name,
                                    value: s.name,
                                  }))}
                                  placeholder={
                                    currency === "INR"
                                      ? "Select State"
                                      : "Select Emirate"
                                  }
                                  disabled={!editable}
                                  onChange={(e) => {
                                    // console.log("Selected Emirate:", e.value);

                                    handleStateChange(e, setFieldValue); // your existing function
                                    setFieldValue("state", e.value);
                                  }}
                                  onBlur={handleBlur}
                                  className={`w-100 ${
                                    touched.state && errors.state
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  style={{
                                    height: "40px",
                                    backgroundColor: "white",
                                    border:
                                      touched.state && errors.state
                                        ? "1px solid #dc3545"
                                        : "1px solid #E9ECEF",
                                  }}
                                />

                                {touched.state && errors.state && (
                                  <div className="invalid-feedback d-block">
                                    {errors.state}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>

                            <Col md={4}>
                              <Form.Group>
                                <Form.Label>Landmark</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="landmark"
                                  placeholder="Enter landmark details..."
                                  value={values.landmark}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled={!editable}
                                  isInvalid={
                                    touched.landmark && errors.landmark
                                  }
                                  className="form-input"
                                  style={{ height: "40px" }}
                                />
                                {touched.landmark && errors.landmark && (
                                  <div className="invalid-feedback d-block">
                                    {errors.landmark}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>

                            <Col md={4}>
                              <Form.Group>
                                <Form.Label>Country</Form.Label>
                                <Dropdown
                                  name="country"
                                  value={currency === "INR" ? 2 : 1}
                                  options={countries?.map((c) => ({
                                    label: c.name,
                                    value: Number(c.country_id),
                                  }))}
                                  placeholder="Select Country"
                                  disabled={!editable}
                                  onChange={(e) => {
                                    // console.log("Selected Country:", e.value);

                                    handleCountryChange(e, setFieldValue); // your existing function
                                    setFieldValue("country", e.value);
                                  }}
                                  onBlur={handleBlur}
                                  className={`w-100 ${
                                    touched.country && errors.country
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  style={{
                                    height: "40px",
                                    backgroundColor: "white",
                                    border:
                                      touched.country && errors.country
                                        ? "1px solid #dc3545"
                                        : "1px solid #E9ECEF",
                                  }}
                                />
                                {touched.country && errors.country && (
                                  <div className="invalid-feedback d-block">
                                    Please select a country
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            {/* <Col md={4}>
                          <Form.Group>
                            <Form.Label>City</Form.Label>
                            <Form.Select
                              name="city"
                              value={values.city}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.city && errors.city}
                              className={`form-input ${
                                values.city === "" ? "placeholder-style" : ""
                              }`}
                              style={{
                                height: "40px",
                                backgroundColor: "white",
                                border:
                                  touched.city && errors.city
                                    ? "1px solid #dc3545"
                                    : "1px solid #E9ECEF",
                              }}
                            >
                              <option value="">Select City</option>
                              {cities.map((city) => (
                                <option key={city.city_id} value={city.city_id}>
                                  {city.name}
                                </option>
                              ))}
                            </Form.Select>
                            {touched.city && errors.city && (
                              <div className="invalid-feedback d-block">
                                {errors.city}
                              </div>
                            )}
                          </Form.Group>
                        </Col> */}
                            <Col md={4}>
                              <Form.Group>
                                <Form.Label>Longitude and Latitude</Form.Label>
                                <Row className="g-2">
                                  <Col>
                                    <Form.Control
                                      type="text"
                                      name="lat"
                                      placeholder="Latitude"
                                      value={values.lat}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      disabled={!editable}
                                      isInvalid={touched.lat && errors.lat}
                                      className="form-input"
                                      style={{
                                        fontSize: "14px",
                                        height: "40px",
                                      }}
                                    />
                                    {touched.lat && errors.lat && (
                                      <div className="invalid-feedback d-block">
                                        {errors.lat}
                                      </div>
                                    )}
                                  </Col>
                                  <Col>
                                    <Form.Control
                                      type="text"
                                      name="lng"
                                      placeholder="Longitude"
                                      value={values.lng}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      disabled={!editable}
                                      isInvalid={touched.lng && errors.lng}
                                      className="form-input"
                                      style={{
                                        fontSize: "14px",
                                        height: "40px",
                                      }}
                                    />
                                    {touched.lng && errors.lng && (
                                      <div className="invalid-feedback d-block">
                                        {errors.lng}
                                      </div>
                                    )}
                                  </Col>
                                </Row>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                      <Accordion.Header>Service Information</Accordion.Header>
                      <Accordion.Body>
                        <div className="service-selection-card mb-4">
                          <div className="mb-4">
                            <h6 className="section-title">
                              Service Category
                              <span style={{ color: "red", fontSize: "1rem" }}>
                                *
                              </span>
                            </h6>

                            {services && services.length > 0 ? (
                              <div className="d-flex gap-3 flex-wrap">
                                {services.map((ele) => (
                                  <div
                                    key={ele.service_id}
                                    onClick={() => setSelectedService(ele)}
                                    className={`service-type-pill ${
                                      ele?.service_id ===
                                      selectedService?.service_id
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    {ele?.service_name}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="text-center p-4 border rounded bg-light">
                                <h6 className="text-danger mb-2">
                                  No Services Available
                                </h6>
                                <p className="text-muted mb-0">
                                  Please add Service & Type from Admin Setup to
                                  continue booking.
                                </p>
                              </div>
                            )}
                          </div>
                          {/* SERVICE TYPE */}
                          {!Object.keys(groupedData).includes("null") && (
                            <div className="mb-4">
                              <h6 className="section-title">
                                Sub Category
                                <span
                                  style={{ color: "red", fontSize: "1rem" }}
                                >
                                  *
                                </span>
                              </h6>

                              <div className="d-flex gap-3 flex-wrap">
                                {Object.keys(groupedData).map((ele) => (
                                  <div
                                    key={ele}
                                    onClick={() => setActiveType(ele)}
                                    className={`service-type-pill ${
                                      ele === activeType ? "active" : ""
                                    }`}
                                  >
                                    {ele}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* SELECT OFFERING */}
                          {services?.length > 0 && (
                            <>
                              {serviceTypes && serviceTypes.length > 0 ? (
                                <div>
                                  <h6 className="section-title">
                                    Service Type
                                    <span
                                      style={{ color: "red", fontSize: "1rem" }}
                                    >
                                      *
                                    </span>
                                  </h6>

                                  <div className="row g-3">
                                    {groupedData?.[activeType]?.map((data) => (
                                      <div className="col-md-3" key={data.id}>
                                        <div
                                          onClick={() => addOffering(data)}
                                          className="offering-row-card d-flex justify-content-between align-items-center"
                                        >
                                          <div>
                                            <div className="fw-semibold">
                                              {data?.service_offering_name}
                                            </div>
                                            <div className="price-text">
                                              {currency} {data?.price}
                                            </div>
                                          </div>

                                          <div
                                            className={`btn btn-sm rounded-3 ${
                                              data?.added
                                                ? "btn-danger"
                                                : "btn-outline-danger"
                                            }`}
                                          >
                                            {data?.added ? "Added" : "Add"}
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ) : (
                                <div className="text-center p-4 border rounded bg-light">
                                  <h6 className="text-danger mb-2">
                                    No Service Types Available
                                  </h6>
                                  <p className="text-muted mb-0">
                                    Please add Service Type under the selected
                                    Service to continue booking.
                                  </p>
                                </div>
                              )}
                            </>
                          )}
                        </div>

                        {/* ================= CARD 2 ================= */}
                        {/* SERVICE INFORMATION */}
                        <div className="service-summary-card">
                          <div className="p-3">
                            {/* DATE + TIME + CREW + STATUS + PAYMENT */}
                            {/* Start Date */}
                            <Row>
                              <Col
                                md={3}
                                style={{ marginBottom: "1%" }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div className="d-flex  flex-column">
                                  <Form.Label>
                                    Select Date
                                    <span
                                      style={{ color: "red", fontSize: "1rem" }}
                                    >
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <button
                                      type="button"
                                      className="btn d-flex align-items-center gap-2 px-3 position-relative"
                                      style={{
                                        height: "40px",
                                        fontSize: "14px",
                                        borderRadius: "6px",
                                        backgroundColor: "#FFFFFF",
                                        border: "1px solid #E3EBF8",
                                        color: "#000000",
                                        justifyContent: "space-between",
                                        width: "100%",
                                      }}
                                      disabled={!editable}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setOpen(!open);
                                      }}
                                    >
                                      {formatDateDisplay(dateSelect)}
                                      <FaRegCalendarAlt className="position-absolute end-0 mx-2" />
                                    </button>

                                    {open && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "100%",
                                          left: "0",
                                          zIndex: 9999,
                                          backgroundColor: "#fff",
                                          boxShadow:
                                            "0 2px 8px rgba(0,0,0,0.15)",
                                          borderRadius: "8px",
                                        }}
                                      >
                                        <DatePicker
                                          inline
                                          selected={dateSelect}
                                          onChange={(date) => {
                                            getWorkerAvailableSlots(date);
                                            setDateSelect(date);
                                            setProviderSelected([]);
                                          }}
                                          dateFormat="dd-MM-yyyy"
                                          className="form-control"
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>

                              {/* Selected Time */}
                              <Col md={3}>
                                <div className="d-flex  flex-column">
                                  <Form.Label>
                                    Selected Time
                                    <span
                                      style={{ color: "red", fontSize: "1rem" }}
                                    >
                                      *
                                    </span>
                                  </Form.Label>
                                  <div
                                    onClick={() => {
                                      setShowCalender(true);
                                      getWorkerAvailableSlots(dateSelect);
                                    }}
                                    className="d-flex gap-2 rounded border p-2"
                                    style={{ height: "40px" }}
                                  >
                                    {convertTo12Hour(timeSelect) || ""}
                                  </div>
                                </div>
                              </Col>

                              {/* Crew */}
                              <Col md={3}>
                                <div className="d-flex  flex-column">
                                  <Form.Label>
                                    Crew
                                    <span
                                      style={{ color: "red", fontSize: "1rem" }}
                                    >
                                      *
                                    </span>
                                  </Form.Label>
                                  <div
                                    onClick={() => {
                                      setShowCalender(true);
                                      getWorkerAvailableSlots(dateSelect);
                                    }}
                                    className="d-flex gap-2 rounded border p-2"
                                    style={{
                                      height: "40px",
                                      overflowY: "scroll",
                                    }}
                                  >
                                    {providerSelected?.map((data, idx) => (
                                      <div
                                        className="flex-center p-2 btn-danger rounded-2"
                                        key={idx}
                                      >
                                        {data?.extendedProps?.search || ""}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </Col>

                              {/* Status */}
                              <Col md={3}>
                                <div className="d-flex  flex-column">
                                  <Form.Label>Status</Form.Label>
                                  <Dropdown
                                    name="status"
                                    value={values.status}
                                    options={bookingStatus?.map((s) => ({
                                      label: s.name,
                                      value: s.id,
                                    }))}
                                    placeholder="Select Status"
                                    onChange={(e) =>
                                      setFieldValue("status", e.value)
                                    }
                                    onBlur={handleBlur}
                                    className={`w-100 ${
                                      touched.status && errors.status
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    style={{
                                      height: "40px",
                                      backgroundColor: "white",
                                      border:
                                        touched.status && errors.status
                                          ? "1px solid #dc3545"
                                          : "1px solid #E9ECEF",
                                    }}
                                  />
                                  {touched.status && errors.status && (
                                    <div className="invalid-feedback d-block">
                                      {errors.status}
                                    </div>
                                  )}
                                </div>
                              </Col>

                              {/* Payment */}
                              <Col md={3}>
                                <div className="d-flex  flex-column">
                                  <Form.Label>Payment</Form.Label>
                                  <Dropdown
                                    name="payment"
                                    value={values.payment}
                                    options={paymentStatus?.map((p) => ({
                                      label: p.name,
                                      value: p.id,
                                    }))}
                                    placeholder="Select Payment"
                                    onChange={(e) => {
                                      setFieldValue("payment", e.value);
                                      const selectedPaymentName =
                                        paymentStatus?.find(
                                          (p) => p.id === e.value
                                        )?.name;

                                      const isPaymentDone = [
                                        "Success",
                                        "Paid online",
                                        "Cash paid",
                                        "Complimentary",
                                      ].includes(selectedPaymentName);

                                      const totalObj = priceSection?.find(
                                        (item) => item.name === "Total"
                                      );

                                      const totalAmount = Number(
                                        totalObj?.amount || 0
                                      );

                                      if (isPaymentDone) {
                                        setPaidAmount(totalAmount);
                                      } else {
                                        setPaidAmount(0);
                                        // setBalanceDue(totalAmount); //  full amount pending
                                      }
                                    }}
                                    onBlur={handleBlur}
                                    className={`w-100 ${
                                      touched.payment && errors.payment
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    style={{
                                      height: "40px",
                                      backgroundColor: "white",
                                      border:
                                        touched.payment && errors.payment
                                          ? "1px solid #dc3545"
                                          : "1px solid #E9ECEF",
                                    }}
                                  />

                                  {touched.payment && errors.payment && (
                                    <div className="invalid-feedback d-block">
                                      {errors.payment}
                                    </div>
                                  )}
                                </div>
                              </Col>
                              <Col md={3}>
                                <div className="d-flex flex-column">
                                  <Form.Label>Total Hours Reserved</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={totalReservedHours}
                                    readOnly
                                    style={{
                                      height: "40px",
                                      background: "#f8f9fa",
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>

                            {/* ================= PRICE SUMMARY ================= */}
                            <div
                              className="border rounded"
                              style={{ marginTop: "10px" }}
                            >
                              {/* Header */}
                              <div className="d-flex justify-content-between align-items-center fw-semibold px-3 py-2 bg-light border-bottom">
                                <div className="d-flex align-items-center gap-3">
                                  <span>Service</span>

                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                                    style={{
                                      fontSize: "13px",
                                      padding: "4px 10px",
                                    }}
                                    onClick={addCustomService}
                                  >
                                    + Add item
                                  </button>
                                </div>

                                <span>Price ({currency})</span>
                              </div>

                              {/* Service Rows */}
                              {priceSection?.map((data, idx) => {
                                const isLabelField =
                                  data?.name?.toLowerCase().includes("tax") ||
                                  data?.name?.toLowerCase().includes("total");

                                return (
                                  <div
                                    key={data.id || data.name}
                                    className={`d-flex justify-content-between align-items-center px-3 py-2 border-bottom ${
                                      isLabelField ? "bg-light fw-semibold" : ""
                                    }`}
                                  >
                                    {data?.isCustom ? (
                                      <Form.Control
                                        type="text"
                                        placeholder="Label"
                                        value={data?.name}
                                        size="sm"
                                        style={{ width: "180px" }}
                                        onChange={(e) =>
                                          customNameChange(e.target.value, idx)
                                        }
                                      />
                                    ) : (
                                      <span>{data?.name}</span>
                                    )}

                                    {isLabelField && !data?.isCustom ? (
                                      <span className="text-muted">
                                        {currency} {data?.amount}
                                      </span>
                                    ) : (
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted">
                                          {currency}
                                        </span>

                                        <Form.Control
                                          type="number"
                                          value={data?.amount}
                                          size="sm"
                                          style={{ width: "100px" }}
                                          onChange={(e) => {
                                            if (data?.isCustom) {
                                              customPriceChange(
                                                e.target.value,
                                                idx
                                              );
                                            } else {
                                              priceChange(e.target.value, data);
                                            }
                                          }}
                                        />
                                        {data?.isCustom && (
                                          <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() =>
                                              deleteCustomItem(idx)
                                            }
                                          >
                                            ✕
                                          </Button>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                              <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom bg-light">
                                <span>Paid Amount</span>
                                <div className="d-flex align-items-center gap-2">
                                  <span>{currency}</span>
                                  <Form.Control
                                    type="number"
                                    value={paidAmount}
                                    size="sm"
                                    style={{ width: "100px" }}
                                    onChange={(e) =>
                                      setPaidAmount(Number(e.target.value))
                                    }
                                  />
                                </div>
                              </div>

                              {/* Balance Due */}
                              <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom bg-light">
                                <span>Balance Due</span>
                                <span>
                                  {currency} {balanceDue > 0 ? balanceDue : 0}
                                </span>
                              </div>
                            </div>
                            <div className="mt-3">
                              <label className="form-label fw-semibold">
                                Additional Notes
                              </label>

                              <Form.Control
                                as="textarea"
                                rows={5}
                                placeholder="Enter any additional notes or service instructions..."
                                value={additionalNotes}
                                onChange={(e) =>
                                  setAdditionalNotes(e.target.value)
                                }
                                style={{
                                  fontSize: "14px",
                                  resize: "none",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                {recentBookings.length > 0 && (
                  <div
                    style={{
                      maxHeight: "300px",
                      overflowY: "auto",
                      borderRadius: "10px",
                      border: "1px solid #dee2e6",
                      background: "#fff",
                    }}
                  >
                    {/* Header */}
                    <div
                      style={{
                        padding: "10px 15px",
                        fontSize: "16px",
                        fontWeight: "600",
                        borderBottom: "1px solid #dee2e6",
                        background: "#f8f9fa",
                      }}
                    >
                      Recent Bookings
                    </div>

                    <Table
                      striped
                      bordered
                      hover
                      size="sm"
                      style={{ marginBottom: 0 }}
                    >
                      <thead
                        style={{ fontSize: "13px", background: "#f1f3f5" }}
                      >
                        <tr>
                          <th>Booking Id</th>
                          <th>Profile Name</th>
                          <th>Service Name</th>
                          <th>Service Type</th>
                          <th>Service Time</th>
                          <th>Service Date</th>
                          <th>Amount</th>
                          <th>Provider</th>
                        </tr>
                      </thead>
                      <tbody style={{ fontSize: "13px" }}>
                        {recentBookings.map((item, index) => (
                          <tr key={index}>
                            <td>{item.display_booking_id}</td>
                            <td>{item.customer_name}</td>{" "}
                            {/* Use customer_name */}
                            <td>{item.service_name}</td>
                            <td>{item.service_type_name}</td>
                            <td>{item.service_time}</td>
                            <td>
                              {new Date(item.service_date).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )}
                            </td>
                            <td>{Number(item.total).toFixed(2)}</td>
                            <td>{item.provider_name}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
                <div className="d-flex justify-content-center mb-0 gap-4">
                  {/* <Button
                variant="light"
                // onClick={handleNavigation}
                className="custom-btn btn-large"
              >
                Cancel
              </Button> */}
                  <Button
                    type="submit"
                    variant="danger"
                    disabled={isSubmitting}
                    className="custom-btn btn-large"
                    style={{ marginTop: "10px" }}
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>

        <Modal className="flex-center calendarMessage" show={!!calenderMessage}>
          <div onClick={() => setCalenderMessage("")} className="closeCalender">
            X
          </div>
          <div style={{ padding: "1rem" }}>{calenderMessage}</div>
        </Modal>

        <Modal
          show={showCalender || !!calenderMessage}
          onHide={onHide}
          centered
          size="xl"
          backdrop={true}
          keyboard={true}
          // backdrop="static"
          dialogClassName="custom-appointment-modal"
          contentClassName="rounded-4 border-0"
        >
          <Modal.Header closeButton className="border-0 pt-4 px-4">
            <Modal.Title className="w-100 fs-5 fw-bold">
              {" "}
              Add Offering
            </Modal.Title>
          </Modal.Header>

          <hr className="mx-4 my-0" />

          <Modal.Body className="px-4 py-4 removeHeader bookingCalender ">
            <div className="d-flex justify-content-between">
              {providerSelected?.length > 0 && (
                <div
                  style={{
                    background: "#F8FAFF",
                    border: "1px solid #E3EBF8",
                    padding: "10px 15px",
                    borderRadius: "8px",
                    marginBottom: "12px",
                    fontWeight: "500",
                    fontSize: "14px",
                    width: "50%",
                  }}
                >
                  <div>
                    <b>Crew Selected:</b> {crewCount}
                  </div>

                  <div>
                    <b>Service Duration:</b> {serviceDuration} hrs
                  </div>

                  <div>
                    <b>Duration Per Cleaner:</b> {durationPerCleaner} mins
                  </div>

                  {/* <div>
                  <b>Total Hours Reserved:</b> {totalReservedHours} hrs
                </div> */}
                </div>
              )}
              <div>
                <h6>How to use:</h6>
                <ul style={{ marginLeft: "2rem" }}>
                  <li>Tap an available slot to assign it to the crew.</li>
                  <li>Tap a selected slot again to unassign it.</li>
                  <li>Red slots are already blocked and unavailable.</li>
                  <li>Click Submit when done.</li>
                </ul>
              </div>
            </div>

            <div
              className={`submitcalendar ${
                providerSelected?.length === 0 ? "fadeBtn" : ""
              } `}
            >
              <button
                onClick={providerSelected?.length === 0 ? passes : onHide}
                className="btn btn-danger"
              >
                Submit
              </button>
            </div>

            {/* <CustomCalendar */}
            <BookingCalendar
              // events={filteredAppointments}
              events={appointments}
              date={dateSelect}
              datesSet={datesSet}
              editable={editable}
              onAppointmentClick={handleAppointmentClick}
              startTime={timeRange?.startTime}
              endTime={timeRange?.endTime}
              scrollToEventId="event-1"
              headerToolbar={editable}
              closeCalendarFUN={onHide}
            />
          </Modal.Body>

          {/* <hr className="mx-4 my-0" />

        <Modal.Footer className="border-0 d-flex justify-content-center gap-3 py-3">
          <Button
            variant="primary"
            className="px-4 rounded"
            // disabled={!selectedDate || !selectedTimes.length}
          >
            Submit
          </Button>
          <Button
            onClick={onHide}
            variant="outline-secondary"
            className="px-4 rounded"
          >
            Cancel
          </Button>
        </Modal.Footer> */}
        </Modal>

        <Modal
          show={showOrderConf}
          onHide={onHideOrderConf}
          centered
          size="xl"
          backdrop="static"
          dialogClassName="custom-appointment-modal addServiceModal"
          contentClassName="rounded-4 border-0"
        >
          <h4 className="text-center text-danger p-2 pb-0 ">
            {group_id ? `Order Updated` : `Order Confirmation`}
          </h4>

          <hr className="mx-4 my-0" />

          <Modal.Body className="px-4 py-4">
            <div className="d-flex gap-2 mb-2 align-items-center  mb-2">
              <label className="label">Order ID: </label>
              <div style={{ marginBottom: "0.25rem" }}>
                {modelData?.booking_id}
              </div>
            </div>
            <div className="d-flex gap-2 mb-2 align-items-center ">
              <label className="label">Selected Service: </label>
              <div style={{ marginBottom: "0.25rem" }}>
                {modelData?.serviceData?.[0]?.service_name}
              </div>
            </div>
            <div className="d-flex gap-2 mb-2 align-items-center ">
              <label className="label">Selected Type: </label>
              <div style={{ marginBottom: "0.25rem" }}>
                {modelData?.serviceData
                  ?.filter((ele) => ele.added)
                  ?.map((ele) => ele?.service_offering_name)
                  .join(", ")}
              </div>
            </div>
            <div className="d-flex gap-2 mb-2 align-items-center ">
              <label className="label">Service Location: </label>
              <div style={{ marginBottom: "0.25rem" }}>{modelData?.state}</div>
            </div>
            <div className="d-flex gap-2 mb-2 align-items-center ">
              <label className="label">Scheduled Date & Time: </label>
              <div style={{ marginBottom: "0.25rem" }}>
                {modelData?.date} @ {convertTo12Hour(modelData?.time)}
              </div>
            </div>
            {modelData?.lat && (
              <div className="d-flex gap-2 mb-2 align-items-center ">
                <label className="label">Google Map Link: </label>
                <div style={{ marginBottom: "0.25rem" }}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`https://www.google.com/maps/search/?api=1&query=${modelData?.lat},
                ${modelData?.lng}`}
                  >
                    https://www.google.com/maps/search/?api=1&query=
                    {modelData?.lat},{modelData?.lng}
                  </a>
                </div>
              </div>
            )}
            <div className="d-flex gap-2 mb-2 align-items-center ">
              <label className="label">Address: </label>
              <div style={{ marginBottom: "0.25rem" }}>
                {modelData?.house_no}, {modelData?.area}, {modelData?.location},{" "}
                {modelData?.landmark}, {modelData?.state}
              </div>
            </div>
            <div className="d-flex gap-2 mb-2 align-items-center ">
              <label className="label">Customer Name: </label>
              <div style={{ marginBottom: "0.25rem" }}>
                {modelData?.userName}
              </div>
            </div>
            <div className="d-flex gap-2 mb-2 align-items-center ">
              <label className="label">Customer Contact: </label>
              <div style={{ marginBottom: "0.25rem" }}>
                {modelData?.phoneNumber}
              </div>
            </div>
          </Modal.Body>
          <div className="d-flex justify-content-center align-items-center mb-2">
            <button
              className="btn btn-danger rounded "
              onClick={onHideOrderConf}
            >
              Close
            </button>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default Bookings;
